import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const FORESTRYSITUATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ForestrySituation.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ForestrySituation.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const FORESTRYSITUATION_CONFIG = {
  entityName: 'ForestrySituation',
  localizationKey: 'Planning::Entity.ForestrySituation',
  fields: FORESTRYSITUATION_FIELDS,
  permission: 'PlanningOperation.ForestrySituations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
